import { render } from "./assessment-resume.vue?vue&type=template&id=160b0c40&scoped=true&ts=true"
import script from "./assessment-resume.vue?vue&type=script&lang=ts"
export * from "./assessment-resume.vue?vue&type=script&lang=ts"

import "./assessment-resume.vue?vue&type=style&index=0&id=160b0c40&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160b0c40"]])

export default __exports__